import { toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0b433b9e"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = ["xlink:href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $options.isExternal ? (_openBlock(), _createElementBlock("div", _mergeProps({
    key: 0,
    style: $options.styleExternalIcon,
    class: "svg-external-icon svg-icon"
  }, _toHandlers($options.listeners, true)), null, 16)) : (_openBlock(), _createElementBlock("svg", _mergeProps({
    key: 1,
    class: $options.svgClass,
    "aria-hidden": "true"
  }, _toHandlers($options.listeners, true)), [_createElementVNode("use", {
    "xlink:href": $options.iconName
  }, null, 8, _hoisted_1)], 16));
}